<template lang="pug">
#HealthAlert
    //- Header Global
    .change-on-mobile
        button.mobile-only.overlay-button(
            v-on:click="toggleSidebar()"
        )
            .btn-change-menu
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg>
        HeaderGlobal(HeaderGlobalHeading="Imigration" :HeaderGlobalBreadcrumb="breadcrumb")

    .box
        .box__header.no-border
            header.flex.items-center.justify-between
                .header-meta
                    h2.subheading Detail Imigration
                .header-cta.flex.items-center

        .box__body.p-4
            SourceTravelHistory(:proses-get-data="keySend")


</template>

<script>
import HeaderGlobal from './../../components/HeaderGlobal.vue'
import { mapState } from 'vuex';
import Loading from '@/components/Loading.vue';
import NoDataAvailable from '@/components/NoDataAvailable.vue';
import { encrypt } from '@/util/crypto';

import SourceTravelHistory from '@/pages/name/SourceTravelHistory.vue'

export default {
    name: 'TravelHistoryResult',
    components: {
        HeaderGlobal,
        Loading,
        NoDataAvailable,
        SourceTravelHistory,
    },
    props: ['resultGlobalBreadcrumb'],
    data() {
        return {
            breadcrumb: [
                this.resultGlobalBreadcrumb,
                {
                    name: 'Health Alert',
                    url: '/result/marketplace',
                },
            ],
            keySend:null,
        };
    },
    computed: {
        ...mapState([
            'load_data_status_travel_history',
            'travel_history',
            'profile_subheader',
            'profile_subheader_name',
            'load_data_status_profile_subheader',
            'load_data_status_profile_subheader_name'
        ]),
        status_subheader(){
            return {
                'sub':this.load_data_status_profile_subheader, 
                'name':this.load_data_status_profile_subheader_name
            }
        }
        // key() {
        //     return this.$route.params.key;
        // },
    },
    watch: {
        status_subheader(newData) {
            console.log('status_subheader - newData')
            console.log({newData})
            // EventEmit.$emit('openSearchByNamePaspor', 'test');
            // this.keySend = 'test'
            if (newData && (newData.name && newData.name.status === 'loading') || (newData.sub && newData.sub.status === 'loading')){
                this.$store.commit('setLoadDataStatusSearchByNameTravelHistory','loading');
            }else{
                let dataSub = this.profile_subheader
                let dataSubName = this.profile_subheader_name
                
                if (dataSubName.name && dataSubName.name!='-'){
                    this.keySend = dataSubName.name
                }
                else if (dataSub.name && dataSub.name!='-'){
                    this.keySend = dataSub.name
                    // console.log('TravelHistoryResult - watch - emit:openSearchByNamePaspor')
                }else{
                    this.$store.commit('setLoadDataStatusSearchByNameTravelHistory','empty');
                    // console.log('TravelHistoryResult - watch - comit:setLoadDataStatusSearchByNameTravelHistory:empty')
                }
            }
        },
    },
    methods: {
        toggleSidebar() {
            EventEmit.$emit('toggleSidebar')
        },
        encrypt(key, type) {
            return encrypt(key+ '&&' +type);
        },
    },
    mounted() {
        this.$store.commit('setLoadDataStatusSearchByNameTravelHistory','loading');
        // console.log('TravelHistoryResult - mounted - setLoadDataStatusSearchByNameTravelHistory:loading')

        let profileSub = this.profile_subheader
        let profileSubName = this.profile_subheader_name
        // console.log('TravelHistoryResult - mounted - profileSub')
        // console.log({profileSub})
        console.log({profileSub, profileSubName})

        if (profileSubName && profileSubName.name && profileSubName.name!='-')
            this.keySend = profileSubName.name
        else if (profileSub && profileSub.name && profileSub.name!='-')
            this.keySend = profileSub.name
            // EventEmit.$emit('openSearchByNameTravelHistory');
        
    },
}
</script>

<style lang="sass">
</style>
